import { useContext } from 'react';

import styled from 'styled-components';

import { useIsSidebarActive } from '@components/sidebar';

import { TestIdContext } from 'ui/authenticated/main/helpers';
import { SourceHandle, TargetHandle } from 'ui/journey-builder/node-types/node-container';
import { JourneyNodeBase } from 'ui/journey-builder/node-types/types';

import { TravellerJourneyNode } from './types';

import { showActionSidebar } from '../action-sidebar';

const StyledNodeContainer = styled.div<{ $width?: string; $disableClick?: boolean }>(
  ({ $width, $disableClick }) => ({
    width: $width ?? '320px',
    display: 'flex',
    justifyContent: 'center',
    cursor: $disableClick ? 'default' : 'pointer',
  }),
);

type NodeContainerProps = {
  node: TravellerJourneyNode;
  width?: string;
  hideTargetHandle?: boolean;
  hideSourceHandle?: boolean;
  disableClick?: boolean;
};

export const NodeContainer: React.FC<NodeContainerProps> = ({
  node,
  width,
  hideTargetHandle = false,
  hideSourceHandle = false,
  disableClick = false,
  ...rest
}) => {
  const isActive = useIsSidebarActive(node.id);
  const descriptiveMap = useContext(TestIdContext);
  const handleColor = isActive ? 'elementBlue100' : 'purple20';

  return (
    <StyledNodeContainer
      data-testid={descriptiveMap[node.id]}
      $width={width}
      $disableClick={disableClick}
      onClick={disableClick ? undefined : () => showActionSidebar(node as JourneyNodeBase)}
      {...rest}
    >
      {!hideTargetHandle && (
        <TargetHandle $color={handleColor}>
          <div />
        </TargetHandle>
      )}
      {rest.children}
      {!hideSourceHandle && (
        <SourceHandle $color={handleColor}>
          <div />
        </SourceHandle>
      )}
    </StyledNodeContainer>
  );
};
